/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisMomentResponse } from '../../models/platform-ephemeris-moment-response';

export interface GetEphemerisMoment$Params {

/**
 * Het moment (ISO-8601, UTC). Verplicht.
 */
  atUtc?: string | null;
}

export function getEphemerisMoment(http: HttpClient, rootUrl: string, params?: GetEphemerisMoment$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisMomentResponse>> {
  const rb = new RequestBuilder(rootUrl, getEphemerisMoment.PATH, 'get');
  if (params) {
    rb.query('atUtc', params.atUtc, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisMomentResponse>;
    })
  );
}

getEphemerisMoment.PATH = '/api/Ephemeris/moment';
